if (!customElements.get('card-quick-add')) {
  customElements.define(
    'card-quick-add',
    class CardQuickAdd extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.omnee-card-quick-add__toggle');
        this.options = this.querySelector('.omnee-card-size-pills');
        if (!this.toggleButton || !this.options) return;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);

        this.toggleButton.addEventListener('click', this.handleToggle);
        this.options.addEventListener('click', this.handleOptionClick);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.handleToggle);
        this.options?.removeEventListener('click', this.handleOptionClick);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
      }

      handleToggle(event) {
        event.preventDefault();
        event.stopPropagation();

        const shouldOpen = !this.classList.contains('is-open');
        document.querySelectorAll('card-quick-add.is-open').forEach((quickAdd) => {
          if (quickAdd !== this && typeof quickAdd.close === 'function') quickAdd.close();
        });

        this.classList.toggle('is-open', shouldOpen);
        this.toggleButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        if (shouldOpen) this.options.scrollTo({ left: 0, behavior: 'auto' });
      }

      handleOptionClick(event) {
        if (!event.target.closest('.omnee-card-size-pills__pill')) return;
        event.stopPropagation();
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') this.close();
      }

      close() {
        this.classList.remove('is-open');
        this.toggleButton?.setAttribute('aria-expanded', 'false');
      }
    }
  );
}
